// @core/api/endpoints/analytics/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateDashboard } from './create_dashboard';
import { CreateReportSchedule } from './create_report_schedule';
import { CreateSavedQuery } from './create_saved_query';
import { CreateWidget } from './create_widget';
import { DeleteDashboard } from './delete_dashboard';
import { DeleteReport } from './delete_report';
import { DeleteReportSchedule } from './delete_report_schedule';
import { DeleteSavedQuery } from './delete_saved_query';
import { DeleteWidget } from './delete_widget';
import { DuplicateDashboard } from './duplicate_dashboard';
import { GenerateReport } from './generate_report';
import { GetDashboard } from './get_dashboard';
import { GetReport } from './get_report';
import { GetSavedQuery } from './get_saved_query';
import { GetWidget } from './get_widget';
import { ListAvailableDataSources } from './list_available_data_sources';
import { ListDashboards } from './list_dashboards';
import { ListReportSchedules } from './list_report_schedules';
import { ListReports } from './list_reports';
import { ListSavedQueries } from './list_saved_queries';
import { QueryAggregation } from './query_aggregation';
import { QueryData } from './query_data';
import { QueryTimeSeries } from './query_time_series';
import { ShareDashboard } from './share_dashboard';
import { UpdateDashboard } from './update_dashboard';
import { UpdateReportSchedule } from './update_report_schedule';
import { UpdateSavedQuery } from './update_saved_query';
import { UpdateWidget } from './update_widget';

// Re-export individual endpoints
export {
  CreateDashboard,
  CreateReportSchedule,
  CreateSavedQuery,
  CreateWidget,
  DeleteDashboard,
  DeleteReport,
  DeleteReportSchedule,
  DeleteSavedQuery,
  DeleteWidget,
  DuplicateDashboard,
  GenerateReport,
  GetDashboard,
  GetReport,
  GetSavedQuery,
  GetWidget,
  ListAvailableDataSources,
  ListDashboards,
  ListReportSchedules,
  ListReports,
  ListSavedQueries,
  QueryAggregation,
  QueryData,
  QueryTimeSeries,
  ShareDashboard,
  UpdateDashboard,
  UpdateReportSchedule,
  UpdateSavedQuery,
  UpdateWidget,
};

// Namespace export for convenient usage
export const analyticsApi = {
  CreateDashboard,
  CreateReportSchedule,
  CreateSavedQuery,
  CreateWidget,
  DeleteDashboard,
  DeleteReport,
  DeleteReportSchedule,
  DeleteSavedQuery,
  DeleteWidget,
  DuplicateDashboard,
  GenerateReport,
  GetDashboard,
  GetReport,
  GetSavedQuery,
  GetWidget,
  ListAvailableDataSources,
  ListDashboards,
  ListReportSchedules,
  ListReports,
  ListSavedQueries,
  QueryAggregation,
  QueryData,
  QueryTimeSeries,
  ShareDashboard,
  UpdateDashboard,
  UpdateReportSchedule,
  UpdateSavedQuery,
  UpdateWidget,
};
